/**
 * Semantic border-radius tokens.
 *
 * All values in pixels. Eliminates per-component radius drift — components
 * should reference these tokens, never raw numbers.
 */

export const radii = {
  none: 0,
  input: 10, // form fields, selects, number inputs
  tile: 12, // KPI tiles
  card: 14, // standard card
  toast: 14, // toast / notification surface
  modal: 16, // dialogs, modals
  pill: 999, // chips, badges, pill buttons
} as const;

export type RadiusToken = keyof typeof radii;
